/**
 * Zentrale Registry aller Reducer und Effects der App.
 *
 * - Pro Feature liegt ein {feature}-reducer.ts und ein {feature}-effects.ts.
 * - Hier zusammengeführt — `storeConfig` in navigation.ts greift auf diese Exports zu.
 * - `appLoadingEffects` registriert die generischen Loading/Toast-Effects gegen
 *   alle deklarierten AsyncActionGroups.
 */

import { profileReducer } from "../../modules/members/profile/store/profile-reducer.js";
import { profileEffects } from "../../modules/members/profile/store/profile-effects.js";

import { bookmarksReducer } from "../../modules/members/bookmarks/store/bookmarks-reducer.js";
import { bookmarksEffects } from "../../modules/members/bookmarks/store/bookmarks-effects.js";

import { startseiteReducer } from "../../modules/home/store/startseite-reducer.js";
import { startseiteEffects } from "../../modules/home/store/startseite-effects.js";

import { entscheidungenReducer } from "../../modules/entscheidungen/store/entscheidungen-reducer.js";
import { entscheidungenEffects } from "../../modules/entscheidungen/store/entscheidungen-effects.js";

import { gebietReducer } from "../../modules/gebiet/store/gebiet-reducer.js";
import { gebietEffects } from "../../modules/gebiet/store/gebiet-effects.js";

import { bvReducer } from "../../modules/bezirksvertretung/store/bv-reducer.js";
import { bvEffects } from "../../modules/bezirksvertretung/store/bv-effects.js";

import { gremienReducer } from "../../modules/gremien/store/gremien-reducer.js";
import { gremienEffects } from "../../modules/gremien/store/gremien-effects.js";

import { sitzungenReducer } from "../../modules/sitzungen/store/sitzungen-reducer.js";
import { sitzungenEffects } from "../../modules/sitzungen/store/sitzungen-effects.js";

import { parteienReducer } from "../../modules/parteien/store/parteien-reducer.js";
import { parteienEffects } from "../../modules/parteien/store/parteien-effects.js";

import { wahlenReducer } from "../../modules/wahlen/store/wahlen-reducer.js";
import { wahlenEffects } from "../../modules/wahlen/store/wahlen-effects.js";

import { appLoadingEffects } from "./app-loading-effects.js";

export const defaultReducer = {
  profile: profileReducer,
  bookmarks: bookmarksReducer,
  startseite: startseiteReducer,
  entscheidungen: entscheidungenReducer,
  gebiet: gebietReducer,
  bezirksvertretung: bvReducer,
  gremien: gremienReducer,
  sitzungen: sitzungenReducer,
  parteien: parteienReducer,
  wahlen: wahlenReducer,
};

export const defaultEffects = [
  ...profileEffects,
  ...bookmarksEffects,
  ...startseiteEffects,
  ...entscheidungenEffects,
  ...gebietEffects,
  ...bvEffects,
  ...gremienEffects,
  ...sitzungenEffects,
  ...parteienEffects,
  ...wahlenEffects,
  ...appLoadingEffects,
];
